import { render } from "./filters.vue?vue&type=template&id=b04b8ad2&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"

import "./filters.vue?vue&type=style&index=0&id=b04b8ad2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04b8ad2"]])

export default __exports__